@import 'styles/mixins';

.togglesContainer {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
  border: 1px solid var(--dark-4);
  border-radius: 10px;
  padding: 10px;
  width: 440px;

  @include for-phone-only {
    width: 100%;
  }
}

.toggleIconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.toggleContainer {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 0 5px;
  justify-content: space-between;
}

.enableToggleContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 25px;
  gap: 16px;
}

.enableToggleContent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
